import React from 'react';
import { FormattedMessage } from 'react-intl';

const HeaderSinglePaymentEvenSplit = () => (
  <div className="modal-section modal-title text-center divider full blue">
    <div className="header-single-payment-even-split">
      <h1>
        <FormattedMessage
          id="autoPilot.header.singlePayment.evenSplit.title"
          defaultMessage="Autopilot"
        />
      </h1>
      <FormattedMessage
        id="autoPilot.header.singlePayment.evenSplit.subtitle"
        defaultMessage="Set a threshold to automatically make your purchase.
          You can update it anytime prior to reaching the threshold.
          Otherwise, you must return to trigger the purchase manually."
      />
    </div>
  </div>
);

export default HeaderSinglePaymentEvenSplit;



// WEBPACK FOOTER //
// ./src/desktop/components/purchase-dashboard/autopilot/header.single-payment.even-split.js